export const UpXs = () => {
	return <></>;
}